export { ConnectedAddressContainer as AddressContainer } from './AddressContainer'



// WEBPACK FOOTER //
// ./src/containers/Cart/Address/index.js